exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "foreignObject#title{pointer-events:none}foreignObject#label{pointer-events:none}foreignObject#radio-text{pointer-events:none}.ell{overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}\n", ""]);

